import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import SubjektApi from "../api/gen/cgo/SubjektApi";
import * as opravneniActions from "../actions/opravneniActions";
import * as EnumRole from "../api/gen/cgo/EnumRole";
import {withTranslation, WithTranslation} from "react-i18next";

const {Form, FormBody, FormActions} = form;

/**
 * Formulář pro připojení uživatele ke společnosti.
 */
class PripojitZamestnanceForm extends Component<WithTranslation> {

    static formName = 'PripojitZamestnanceForm';

    static propTypes = {
        mimoSpolecnostId: PropTypes.number.isRequired, // ID společnosti ke které se bude připojovat zaměstnanec
    };

    filterSuggestions = (value) => {
        const {mimoSpolecnostId} = this.props;
        return SubjektApi.getUzivatele(value, false, mimoSpolecnostId);
    };

    render() {
        const {onClose, submitting, handleSubmit, loggedInUser, t} = this.props;

        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>{loggedInUser.data.role === EnumRole.ADMIN ?
                <ff.ApiObjectSuggest
                    label={t('admin.user')}
                    name="uzivatel"
                    dropdown={false}
                    removable={false}
                    itemValueAttrName="zobrazJmeno"
                    renderSuggestion={(item) => item ? item.zobrazJmeno + ' (' + item.loginName + ')': ""}
                    filterSuggestions={this.filterSuggestions}
                    placeholder={t('search_for_user')}
                /> : <ff.String label={t('admin.user')} name="uzivatel" placeholder={t('enter_user_login')} />}
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: PripojitZamestnanceForm.formName,
})(PripojitZamestnanceForm)));
